// libraries
import React, { useState } from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Button from '/react4xp/components/Button'

// utils
import { email as buildMailto, phone as buildPhoneHref } from '/lib/reactutils/utils'

export interface StaffDepartment {
    id: string
    name: string
    buttonColor?: 'primary' | 'secondary' | 'tertiary'
}

export interface StaffMember {
    name: string
    position?: string
    description?: string
    email?: string
    phone?: string
    imageSrc?: string
    departments?: string[]
}

export interface StaffProps {
    departments?: StaffDepartment[]
    members?: StaffMember[]
    background?: 'primary' | 'secondary' | 'tertiary' | 'tertiary-10' | 'white'
}

export default function Staff({

    departments = [],
    members = [],
    background = 'white'
}: StaffProps) {
    const [activeDepartment, setActiveDepartment] = useState<string | null>(
        departments.length > 0 ? departments[0].id : null
    )

    const visibleMembers = activeDepartment
        ? members.filter((member) =>
            !member.departments ||
            member.departments.length === 0 ||
            member.departments.includes(activeDepartment)
        )
        : members

    if (!members.length) {
        return null
    }

    return (
        <Section
            className='staff'
           
        >
            <div className='staff__container container'>
                {departments.length > 0 && visibleMembers.length > 0 && (
                    <nav className='staff__nav'>
                        <div className='staff__nav-list'>
                            {departments.map((department) => (
                                <React.Fragment key={department.id}>
                                    <Button
                                        type='button'
                                        color='primary'
                                        style={activeDepartment === department.id ? 'solid' : 'hollow'}
                                        className='staff__nav-button'
                                        small
                                        onClick={() => setActiveDepartment(department.id)}
                                    >
                                        {department.name}
                                    </Button>
                                </React.Fragment>
                            ))}
                        </div>
                    </nav>
                )}

                <div className='staff__list'>
                    {visibleMembers.map((member, index) => (
                        <div key={index} className='staff__card'>
                            <div className={clsx('staff__image', !member.imageSrc && 'staff__image--placeholder')}>
                                {member.imageSrc && <img src={member.imageSrc} alt='' loading='lazy' />}
                            </div>
                            <div className='staff__content'>

                                <h5 className='staff__name'>{member.name}</h5>
                                <div className='staff__contact'>
                                    {member.position && (
                                        <p className='staff__position'>{member.position}</p>
                                    )}


                                    {member.email && (
                                        <a className='staff__email' href={buildMailto(member.email)}>
                                            {member.email}
                                        </a>
                                    )}

                                    {member.phone && (
                                        <a className='staff__phone' href={buildPhoneHref(member.phone)}>
                                            {member.phone}
                                        </a>
                                    )}
                                </div>
                                {member.description && (
                                    <p className='staff__description' dangerouslySetInnerHTML={{ __html: member.description }} suppressHydrationWarning />
                                )}

                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Section>
    )
}
